import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { MODIFIER_COLORS } from '../../../../constants/modifier-colors.constant';
import { ModifierPromptOptionType } from 'src/app/models/pos-manager.model';

@Component({
  selector: 'pos-edit-option',
  templateUrl: './edit-option.modal.html',
  styleUrls: ['./edit-option.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditOptionModal implements OnInit {
  @Input('name') name: string;
  @Input('price') price: number;
  @Input('modifier_color') modifier_color: string;
  @Input('option_type') option_type: ModifierPromptOptionType;

  readonly form = this.fb.group({
    name: ['', Validators.required],
    price: [null, null],
    modifier_color: [null, null]
  });

  readonly colors = MODIFIER_COLORS;
  readonly ModifierPromptOptionType = ModifierPromptOptionType;

  readonly MODIFIER_OPTIONS = [
    { name: 'Text Modifier', value: 'text' },
    { name: 'Category', value: 'category' },
    { name: 'Product', value: 'pos_product' }
  ];

  constructor(
    private modalController: ModalController,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.form.setValue({
      name: this.name || '',
      price: this.price || null,
      modifier_color: this.modifier_color || null
    });
    this.cdr.detectChanges();
    console.log(this.form.getRawValue());
  }

  selectColor(value: string | null) {
    this.form.patchValue({ modifier_color: value });
    this.form.markAsDirty();
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    const { name, price, modifier_color } = this.form.getRawValue();

    this.modalController.dismiss({
      name,
      price,
      modifier_color
    });
  }

  get isReadonlyType(): boolean {
    return (
      this.option_type === ModifierPromptOptionType.PosProduct ||
      this.option_type === ModifierPromptOptionType.Category
    );
  }

  get modifierTypeName(): string {
    const option = this.MODIFIER_OPTIONS.find(
      (opt) => opt.value === this.option_type
    );
    return option ? option.name : 'Unknown';
  }
}
